import {
  Box,
  Image,
  LinkBox,
  LinkOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { search_result_clicked } from '@/analytics';
import { SearchHelpers } from '@/client/legacy-shared-modules/search/helpers';
import { IOrganizationSearch } from '@/client/legacy-shared-modules/search/search-types';
import { CustomHighlight } from '@/components/CustomHighlight';
import { CustomSnippet } from '@/components/CustomSnippet';
import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';

export const Organization: React.FC<{
  hit: IOrganizationSearch;
  query?: string;
  position?: number;
}> = ({ hit, query, position }) => {
  const handleClick = () => {
    search_result_clicked({
      entity: {
        id: hit.objectID,
        type: 'organization',
      },
      search: {
        query: query || '',
        searchType: 'organizations',
      },
      engagement: {
        position,
      },
    });
  };

  return (
    <LinkBox
      as={Stack}
      direction="row"
      spacing="2"
      alignItems="center"
      p="2"
      bg="white"
      _hover={{ bg: 'gray.100' }}
      borderRadius="xl"
      cursor="pointer"
      onClick={handleClick}
    >
      <Image
        boxSize="8"
        objectFit="cover"
        src={hit.profilePictureUrl ?? undefined}
        alt=""
        borderRadius="base"
        fallback={<ImageFallback boxSize="8" borderRadius="base" />}
      />

      <Box>
        <LinkOverlay as={NextLink} href={`/companies/${hit.objectID}`}>
          <Text noOfLines={1} textStyle="bodyStrong">
            <CustomHighlight attribute="name" hit={hit} />
          </Text>
        </LinkOverlay>

        <Text noOfLines={1} textStyle="compact" color="gray.600">
          <CustomSnippet attribute="aboutUs" hit={hit} />
        </Text>
      </Box>
    </LinkBox>
  );
};
